import http from '../http'

// home
export const queryCurrentUserPlatInfoList = data => {
  return http.request({
    url: '/home/queryCurrentUserPlatInfoList',
    data,
    method: 'post'
  })
}

// user plat
export const queryPlatList = data => {
  return http.request({
    url: '/home/queryPlatList',
    data,
    method: 'post'
  })
}
